module.exports = __webpack_public_path__ + "img/login.27ceb6bf.jpg";